module.exports = __webpack_public_path__ + "img/slide01.45c183d5.png";